/**
 * GENERATED FILE — do not edit.
 *
 * Source: Sportsbook Design System · Fast Track (OesZrQ8iuqaxLwJaf5Zj8f)
 * https://www.figma.com/design/OesZrQ8iuqaxLwJaf5Zj8f/Sportsbook-Design-System-Fast-Track
 * Exported 2026-08-18. Regenerate with `npm run tokens`.
 */

export const SCHEMES = ['g90', 'purple', 'sky', 'amber'] as const;
export type Scheme = (typeof SCHEMES)[number];

export const THEMES = ['dark', 'light'] as const;
export type Theme = (typeof THEMES)[number];

export const DEFAULT_SCHEME: Scheme = 'g90';
export const DEFAULT_THEME: Theme = 'dark';

/**
 * Semantic color tokens as `var()` references, for the rare cases that cannot
 * use a Tailwind utility (inline styles, canvas, chart libraries). Values follow
 * the active `data-scheme` / `data-theme`, so never read the raw hex instead.
 */
export const color = {
  bg: {
    canvas: 'var(--color-bg-canvas)',
    surface: 'var(--color-bg-surface)',
    elevated: 'var(--color-bg-elevated)',
    overlay: 'var(--color-bg-overlay)',
  },
  text: {
    primary: 'var(--color-text-primary)',
    secondary: 'var(--color-text-secondary)',
    disabled: 'var(--color-text-disabled)',
    inverse: 'var(--color-text-inverse)',
    onAction: 'var(--color-text-on-action)',
  },
  border: {
    default: 'var(--color-border-default)',
    subtle: 'var(--color-border-subtle)',
    focus: 'var(--color-border-focus)',
    event: 'var(--color-border-event)',
  },
  action: {
    primary: 'var(--color-action-primary)',
    primaryHover: 'var(--color-action-primary-hover)',
    secondary: 'var(--color-action-secondary)',
    secondaryHover: 'var(--color-action-secondary-hover)',
  },
  odds: {
    default: 'var(--color-odds-default)',
    defaultText: 'var(--color-odds-default-text)',
    selected: 'var(--color-odds-selected)',
    selectedText: 'var(--color-odds-selected-text)',
    suspended: 'var(--color-odds-suspended)',
    up: 'var(--color-odds-up)',
    down: 'var(--color-odds-down)',
  },
  live: {
    indicator: 'var(--color-live-indicator)',
    bg: 'var(--color-live-bg)',
  },
  status: {
    success: 'var(--color-status-success)',
    danger: 'var(--color-status-danger)',
    warning: 'var(--color-status-warning)',
    info: 'var(--color-status-info)',
  },
  icon: {
    default: 'var(--color-icon-default)',
    muted: 'var(--color-icon-muted)',
  },
  header: {
    gradientBase: 'var(--color-header-gradient-base)',
    gradientAccent: 'var(--color-header-gradient-accent)',
  },
  footer: {
    gradientBase: 'var(--color-footer-gradient-base)',
    gradientAccent: 'var(--color-footer-gradient-accent)',
  },
  brand: {
    logoWordmark: 'var(--color-brand-logo-wordmark)',
    logoAccent: 'var(--color-brand-logo-accent)',
  },
} as const;

/** Spacing scale in `var()` form, keyed by step. */
export const space = {
  0: 'var(--space-0)',
  1: 'var(--space-1)',
  2: 'var(--space-2)',
  3: 'var(--space-3)',
  4: 'var(--space-4)',
  5: 'var(--space-5)',
  6: 'var(--space-6)',
  8: 'var(--space-8)',
  10: 'var(--space-10)',
  12: 'var(--space-12)',
  16: 'var(--space-16)',
} as const;

/** Spacing scale in pixels, for measurements that must be numeric. */
export const spacePx = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
} as const;

/** Corner radius scale in `var()` form. */
export const radius = {
  none: 'var(--radius-none)',
  xs: 'var(--radius-xs)',
  sm: 'var(--radius-sm)',
  md: 'var(--radius-md)',
  lg: 'var(--radius-lg)',
  xl: 'var(--radius-xl)',
  full: 'var(--radius-full)',
} as const;

/** Corner radius scale in pixels. */
export const radiusPx = {
  none: 0,
  xs: 2,
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  full: 9999,
} as const;

export const tokens = { color, space, spacePx, radius, radiusPx } as const;
